/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MirrorRectangular = [
  ["path", { d: "M11 6 8 9" }],
  ["path", { d: "m16 7-8 8" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2" }]
];

export { MirrorRectangular as default };
//# sourceMappingURL=mirror-rectangular.js.map
